export const trainProjectsData = [
  {
    _id: "train1",
    title: "Activision",
    description:
      "Designed and developed NiMobile, a fully-featured, responsive e-commerce website specializing in the online sale of mobile phones, digital gadgets, and related accessories. The project involved building a secure, user-friendly online storefront with comprehensive product management, shopping cart functionality, and integrated payment gateways to facilitate end-to-end digital transactions.",
    tech: [],
    image: "/media/LiveProjects/nimobile.png",
    liveUrl: "https://nimobile.vira-tec.ir",
    githubUrl: "",
    color: "rgb(220, 184, 104)",
    stats: { users: "10K+", performance: "99.9%", rating: "4.9" },
    keyFeatures: [
      "Product Catalog & Management: Implemented a dynamic product display system with detailed pages, high-quality images, specifications, categories (e.g., phones, headphones, chargers), and customer reviews/rating",
      "Advanced Shopping Cart & Checkout: Developed a persistent shopping cart and a streamlined, multi-step checkout process",
      "User Account & Order Management: Built customer account functionality for order history tracking, wish lists, and profile management.",
    ],
  },
  {
    _id: "train2",
    title: "Digikala",
    description:
      "Developed a comprehensive web-based software platform to fully automate and monitor the lifecycle of standards samples—from company registration and request submission through intelligent distribution, inspection, lab analysis, and final certification—for a national standards organization. The system replaced manual processes, significantly enhancing accuracy, traceability, and operational transparency",
    tech: [],
    image: "/media/LiveProjects/uis.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-online-shopping-interface-43387-large.mp4",
    liveUrl: "https://ecomarket-shop.com",
    githubUrl: "https://github.com/username/ecomarket",
    color: "rgb(25, 118, 210)",
    stats: { transactions: "50K+", offset: "100T CO₂", partners: "200+" },
    keyFeatures: [
      "Company Portal: Enabled companies to submit formal requests based on specific products and required test types.",
      "Inspection & Management Panel",
    ],
  },
  {
    _id: "train3",
    title: "Plants",
    description:
      "Conceptualized, developed, and launched a dynamic informational and service-oriented website for a prominent IT and cybersecurity solutions company. The platform effectively communicates the company's brand identity, showcases its diverse portfolio of services (including cybersecurity, network infrastructure, and software development), and serves as a lead generation hub.",
    tech: [],
    image: "/media/LiveProjects/kavosh.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-yoga-app-interface-47191-large.mp4",
    liveUrl: "https://kavoshandisheh.ir/",
    githubUrl: "https://github.com/username/zenspace",
    color: "#1a2944",
    stats: { sessions: "1M+", users: "100K+", rating: "4.8" },
    keyFeatures: [
      "Designed and implemented a user-friendly interface to enhance customer experience and streamline the online purchasing journey",
      "Optimized site structure and performance for improved search engine visibility (SEO) and faster load times",
    ],
  },
  {
    _id: "train4",
    title: "Nvidia",
    description:
      "Developed and launched a comprehensive B2B and B2C e-commerce platform for a premium nut products company. The website serves as the primary digital sales channel, featuring product catalogs, detailed descriptions, secure online payment gateways, and customer account management.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/niknamNuts.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(223, 134, 38)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Real-time updates and collaboration",
      "Responsive design across all devices",
      "Optimized performance and SEO",
    ],
  },
  {
    _id: "train5",
    title: "Myket",
    description:
      "Designed and developed a complete, user-centric e-commerce platform specializing in the online sale of stationery and office supplies, featuring product catalog management, secure checkout, and an intuitive customer journey.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/conte.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(254, 202, 48)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Built a dynamic product catalog with advanced categorization, filtering, and detailed product pages (images, descriptions, specifications).",
      "Developed a persistent shopping cart and a streamlined, multi-step secure checkout process.",
      "Created a comprehensive customer account system for order history, wish lists, and profile management.",
    ],
  },
  {
    _id: "train6",
    title: "Instagram",
    description:
      "Designed and developed a complete, user-centric e-commerce platform specializing in the online sale of stationery and office supplies, featuring product catalog management, secure checkout, and an intuitive customer journey.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/conte.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(254, 202, 48)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Built a dynamic product catalog with advanced categorization, filtering, and detailed product pages (images, descriptions, specifications).",
      "Developed a persistent shopping cart and a streamlined, multi-step secure checkout process.",
      "Created a comprehensive customer account system for order history, wish lists, and profile management.",
    ],
  },
  {
    _id: "train7",
    title: "Workout Progress",
    description:
      "Designed and developed a complete, user-centric e-commerce platform specializing in the online sale of stationery and office supplies, featuring product catalog management, secure checkout, and an intuitive customer journey.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/conte.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(254, 202, 48)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Built a dynamic product catalog with advanced categorization, filtering, and detailed product pages (images, descriptions, specifications).",
      "Developed a persistent shopping cart and a streamlined, multi-step secure checkout process.",
      "Created a comprehensive customer account system for order history, wish lists, and profile management.",
    ],
  },
  {
    _id: "train8",
    title: "Blog App",
    description:
      "Designed and developed a complete, user-centric e-commerce platform specializing in the online sale of stationery and office supplies, featuring product catalog management, secure checkout, and an intuitive customer journey.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/conte.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(254, 202, 48)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Built a dynamic product catalog with advanced categorization, filtering, and detailed product pages (images, descriptions, specifications).",
      "Developed a persistent shopping cart and a streamlined, multi-step secure checkout process.",
      "Created a comprehensive customer account system for order history, wish lists, and profile management.",
    ],
  },
  {
    _id: "train9",
    title: "Film",
    description:
      "Designed and developed a complete, user-centric e-commerce platform specializing in the online sale of stationery and office supplies, featuring product catalog management, secure checkout, and an intuitive customer journey.",
    tech: ["React.js", "RTK", "Material UI"],
    image: "/media/LiveProjects/conte.png",
    video:
      "https://assets.mixkit.co/videos/preview/mixkit-programming-interface-with-a-desktop-41568-large.mp4",
    liveUrl: "https://niknamnuts.ir",
    // githubUrl: "https://github.com/username/codecollab",
    color: "rgb(254, 202, 48)",
    stats: { projects: "25K+", developers: "2", uptime: "99.95%" },
    keyFeatures: [
      "Built a dynamic product catalog with advanced categorization, filtering, and detailed product pages (images, descriptions, specifications).",
      "Developed a persistent shopping cart and a streamlined, multi-step secure checkout process.",
      "Created a comprehensive customer account system for order history, wish lists, and profile management.",
    ],
  },
];
